<template>
  <div class="privacy-policy">
    <div class="policy-container">
      <header class="policy-header">
        <h1>中碳普惠云AI服务隐私政策</h1>
        <div class="policy-dates">
          <time>更新日期：2026年06月23日</time>
          <time>生效日期：2026年06月30日</time>
        </div>
      </header>

      <main class="policy-content">
        <!-- 各章节使用section包装 -->
        <section id="overview" class="policy-section">
          <h2>引言</h2>
          <p>
            中碳普惠云科技有限公司（以下简称“我们”），深知个人信息对您的重要性，我们将按照法律法规的规定，采用符合业界标准的安全保护措施，致力于保护您的个人信息安全可控。我们制定本《隐私政策》（以下简称“本政策”）并特别提醒您：
          </p>
          <p>
            本政策适用于我们通过中碳普惠云AI服务平台（以下简称“本平台”）向您提供的产品及/或服务。在使用我们的产品及/或服务前，请您务必仔细阅读并透彻理解本政策，特别是重要条款，您应重点阅读，在确认充分理解并同意后方可使用我们的产品及/或服务。
          </p>
          <p>
            如您对本政策内容有任何疑问、意见或建议，您可以通过本政策文末列明的方式与我们联系。如您不同意本政策的任何内容，您应当立即停止使用我们的产品及/或服务。当您使用我们的任一产品及/或服务时，即表示您已同意我们按照本政策来合法收集、使用和处理您的相关信息。
          </p>
          <p>
            本政策将帮助您了解以下内容：
          </p>
          <p> 一、我们如何收集和使用您的个人信息 </p>
          <p> 二、我们如何使用Cookie和同类技术 </p>
          <p> 三、我们如何共享、转让、公开披露您的个人信息 </p>
          <p> 四、我们如何保存和保护您的个人信息 </p>
          <p> 五、您的权利 </p>
          <p> 六、我们如何处理未成年人的个人信息 </p>
          <p> 七、本政策如何更新 </p>
          <p> 八、如何联系我们 </p>
        </section>

        <section id="overview" class="policy-section">
          <h2>定义</h2>
          <p>
            【个人信息】指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
          </p>
          <p>
            【敏感个人信息】指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
          </p>
          <p>
            【个人信息处理者】指在个人信息处理活动中自主决定处理目的、处理方式的组织或个人。
          </p>
          <p>
            【匿名化处理】指个人信息经过处理无法识别特定自然人且不能复原的过程。
          </p>
        </section>

        <section id="service" class="policy-section">
          <h2>一、我们如何收集和使用您的个人信息</h2>
          <p>
            我们会遵循正当、合法、必要和诚信的原则，仅为实现产品功能、向用户提供服务等目的，收集和使用您的个人信息。
          </p>
          <div class="section-content">
            <div class="sub-section">
              <h3>1.1 我们会收集的信息</h3>
              <div class="content-box">
                <p>
                  （一）您主动向我们提供的信息
                </p>
                <p>
                  a. 注册信息：当您注册账号时，我们会收集您的手机号码、电子邮件等基本信息。手机号码属于您的个人敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求，帮助您完成注册、保护您的账号安全。
                </p>
                <p>
                  b. 使用服务时产生的信息：为提供对话和内容生成服务，我们需要收集和处理您输入的文字、语音、图片、文件等信息。当您使用剪贴板粘贴功能时，我们需要访问并处理您的剪贴板内容。为实现连续的对话体验，我们需要保存您的历史对话记录。
                </p>
                <p>
                  c. 反馈与客服信息：当您反馈问题、提出建议、投诉或联系我们寻求支持时，我们可能会收集您主动提供的联系方式（如邮箱）、问题描述等相关信息。
                </p>
                <p>
                  （二）我们自动收集的信息
                </p>
                <p>
                  a. 设备与日志信息：当您使用我们的服务时，系统会自动记录您的访问时间、IP地址、设备型号、操作系统版本、浏览器类型等信息，用于保障服务安全和统计分析。
                </p>
                <p>
                  b. Cookie和类似技术：我们可能会使用Cookie和类似技术来了解您的使用习惯，以便提供更个性化的服务。详见本政策第二部分。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.2 我们如何使用您的个人信息</h3>
              <div class="content-box">
                <p>
                  我们收集和使用您的个人信息主要出于以下目的：
                </p>
                <p>
                  （1）为您提供、维护和改进我们的产品及/或服务，包括为您提供AI对话、内容生成等功能；
                </p>
                <p>
                  （2）验证您的身份，进行账号管理和安全防护；
                </p>
                <p>
                  （3）回应您的咨询、建议或投诉，改善客户服务；
                </p>
                <p>
                  （4）优化产品功能和用户体验，开展数据分析与研究；
                </p>
                <p>
                  （5）经您明确授权的其他用途。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.3 征得授权同意的例外</h3>
              <div class="content-box">
                <p>
                  根据《中华人民共和国个人信息保护法》等相关法律法规规定，在以下情形中，我们收集、使用您的个人信息无需征得您的同意：
                </p>
                <p>
                  （1）为订立、履行您作为一方当事人的合同所必需；
                </p>
                <p>
                  （2）为履行法定职责或者法定义务所必需，例如与国家安全、刑事侦查、审判和执行等有关的活动；
                </p>
                <p>
                  （3）为应对突发公共卫生事件，或者在紧急情况下为保护自然人的生命健康和财产安全所必需；
                </p>
                <p>
                  （4）为公共利益实施新闻报道、舆论监督等行为，并在合理的范围内处理个人信息；
                </p>
                <p>
                  （5）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；
                </p>
                <p>
                  （6）法律、行政法规规定的其他情形。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="account" class="policy-section">
          <h2>二、我们如何使用Cookie和同类技术</h2>
          <div class="section-content">
            <div class="sub-section">
              <div class="content-box">
                <p>
                  为确保服务正常运行，我们会在您的计算机或移动设备上存储名为Cookie的小型数据文件。Cookie通常包含标识符、站点名称以及一些数字和字符。借助Cookie，网站能够存储您的偏好等数据。
                </p>
                <p>
                  我们使用Cookie的目的主要包括：
                </p>
                <p>
                  （1）保障产品的安全、高效运转，识别您的身份状态；
                </p>
                <p>
                  （2）帮助我们分析服务使用情况，优化用户体验；
                </p>
                <p>
                  （3）记住您的偏好设置，提供个性化服务。
                </p>
                <p>
                  您可以根据自己的偏好管理或清除Cookie。大多数浏览器都提供了清除Cookie的功能，您可以在浏览器设置中进行操作。但请注意，如果禁用Cookie，您可能无法充分利用我们的部分或全部服务功能。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="rights" class="policy-section">
          <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>3.1 共享</h3>
              <div class="content-box">
                <p>
                  除以下情形外，未经您事先同意，我们不会与第三方共享您的个人信息：
                </p>
                <p>
                  （1）获得您的明确同意后；
                </p>
                <p>
                  （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求而对外提供；
                </p>
                <p>
                  （3）与我们的关联公司共享：为便于我们共同向您提供服务，您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，并采取同等严格的安全保护措施；
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>3.2 转让</h3>
              <div class="content-box">
                <p>
                  我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                </p>
                <p>
                  （1）获得您的明确同意后；
                </p>
                <p>
                  （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求而进行转让；
                </p>
                <p>
                  （3）在我们发生合并、收购或破产清算时，如涉及个人信息转让，我们会告知您接收方的名称/姓名和联系方式，并要求其继续受本政策约束。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>3.3 公开披露</h3>
              <div class="content-box">
                <p>
                  除以下情形外，未经您事先同意，我们不会公开披露您的个人信息：
                </p>
                <p>
                  （1）获得您的单独同意；
                </p>
                <p>
                  （2）根据法律法规要求，或基于司法机关、行政执法部门依法要求而必须公开披露的情况。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="rules" class="policy-section">
          <h2>四、我们如何保存和保护您的个人信息</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>4.1 保存期限</h3>
              <div class="content-box">
                <p>
                  （1）保存期限：我们只会在达成本政策所述目的所需的期限内保留您的个人信息，法律法规另有规定或您另行授权同意的除外。超过上述期限后，我们将对您的个人信息进行删除或匿名化处理
                </p>
                <p>
                  （2）保存地域：我们在中华人民共和国境内收集和产生的个人信息将存储在境内。如确需向境外传输，我们会严格按照法律法规的规定执行，并通过签订标准合同等方式保障您的权益。
                </p>
                <p>
                  （3）终止服务后的处理：当您注销账号后，我们将停止为您提供产品或服务，并根据法律法规要求在合理期限内删除或匿名化处理您的个人信息。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>4.2 信息的保护</h3>
              <div class="content-box">
                <p>
                  我们非常重视信息安全，采取了符合行业标准的安全保护措施来保护您的个人信息，防止其遭到未经授权访问、公开披露、使用、修改、损坏或丢失。具体措施包括：
                </p>
                <p>
                  （1）技术安全措施：采用加密技术、去标识化/匿名化处理等技术手段保护您的个人信息；
                </p>
                <p>
                  （2）管理制度：建立专门的安全管理部门和安全管理制度，对员工进行安全培训；
                </p>
                <p>
                  （3）安全监控：建立信息安全事件的监测和应急响应机制，及时发现和处置安全威胁；
                </p>
                <p>
                  （4）合规审计：定期接受内部和外部的安全审计，确保安全措施的持续有效性。
                </p>
                <p>
                  尽管我们已经按照相关法律法规要求采取了合理有效的安全措施，但由于互联网环境的复杂性和技术的局限性，我们不能保证百分之百的信息安全。请您了解并理解，我们所提供的系统和通信网络可能会受到无法控制的因素影响而出现问题。如发生个人信息安全事件，我们将及时通知您并采取补救措施。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="copyright" class="policy-section">
          <h2>五、您的权利</h2>
          <div class="section-content">
            <p>
              按照中国相关法律法规（《中华人民共和国民法典》《中华人民共和国个人信息保护法》等），您对您的个人信息享有以下权利：
            </p>
            <div class="sub-section">
              <h3>5.1 访问和获取副本权</h3>
              <div class="content-box">
                <p>
                  您有权访问您的个人信息并获得副本。您可以通过本政策文末列明的方式联系我们行使此权利。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.2 更正权</h3>
              <div class="content-box">
                <p>
                  当您发现我们处理的关于您的个人信息不准确或不完整时，您有权要求我们进行更正或补充。您可以通过账号设置界面或联系客服进行更正。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.3 删除权</h3>
              <div class="content-box">
                <p>
                  在以下情形中，您有权要求我们删除您的个人信息：
                </p>
                <p>
                  （1）处理目的已实现、无法实现或者为实现处理目的不再必要；
                </p>
                <p>
                  （2）我们停止提供产品或服务，或者保存期限已届满；
                </p>
                <p>
                  （3）您撤回同意；
                </p>
                <p>
                  （4）我们违反法律、行政法规或者双方约定处理您的个人信息；
                </p>
                <p>
                  （5）法律、行政法规规定的其他情形。
                </p>
                <p>
                  请注意，当我们依据法律法规从第三方间接获取您的个人信息时，删除权的行使可能受到一定限制。此外，法律法规规定的必要保存期限内，我们可能只能进行删除标记或匿名化处理。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.4 撤回同意权</h3>
              <div class="content-box">
                <p>
                  您可以随时撤回此前作出的同意授权。您可以通过更改账号设置、关闭特定功能或联系我们来撤回同意。当您撤回同意后，我们将不再处理相应的个人信息。但您撤回同意的决定，不影响此前基于您的同意已进行的个人信息处理活动的效力。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.5 注销账号权</h3>
              <div class="content-box">
                <p>
                  您可以随时联系我们申请注销账号。账号注销后，我们将停止为您提供产品或服务，并依照法律法规的要求删除或匿名化处理您的个人信息。注销账号后，相关数据可能无法恢复，请您谨慎操作。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>5.6 权利行使方式</h3>
              <div class="content-box">
                <p>
                  您可以通过本政策文末列明的联系方式就上述权利的行使与我们取得联系。为保障安全，我们可能需要先核实您的身份后再处理您的请求，我们将在15个工作日内或在法律法规要求的时限内作出答复。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="liability" class="policy-section">
          <h2>六、我们如何处理未成年人的个人信息</h2>
          <div class="section-content">
            <p>
              我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，尤其是14周岁以下的儿童，请在监护人陪同下仔细阅读本政策，并应在监护人明确同意和指导下使用我们的产品和/或服务或向我们提供信息。
            </p>
            <p>
              如果我们发现在未事先获得监护人同意的情况下收集了未成年人的个人信息，我们将尽快删除相关数据。
            </p>
            <p>
              对于经监护人同意而收集未成年人个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下处理此类信息。
            </p>
            <p>
              如果您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策文末列明的联系方式与我们联系。
            </p>
          </div>
        </section>
        <section id="liability2" class="policy-section">
          <h2>七、如何联系我们</h2>
          <div class="section-content">
            <p>
              中碳普惠云科技有限公司是本平台产品的个人信息处理者。如果您对本政策有任何疑问、意见或建议，或者需要行使您的个人信息相关权利，您可以通过以下方式与我们联系：
            </p>
            <p>
              联系人：中碳普惠云科技有限公司
            </p>
            <p>
              联系邮箱：customerservice@carbonneutrality-group.com
            </p>
            <p>
              公司地址：南通高新技术产业开发区新世纪大道1188号江海智汇园C1楼4层
            </p>
            <p>
              一般情况下，我们将在15个工作日内回复您的请求。如您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以向网信部门、电信主管部门、公安及市场监管等部门进行投诉或举报，或向有管辖权的人民法院提起诉讼。
            </p>
          </div>
        </section>
      </main>
      <footer class="footer">
        <div class="bold-text">
          本隐私政策由中碳普惠云科技有限公司所有，保留一切解释权利。
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy-policy {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  font-size: 18px;
  color: #404040;
}

/* 内容区样式 */
.policy-container {
  min-width: 0;
  width: 100%;
}

.policy-header {
  text-align: center;
}

.policy-dates {
  color: #666;
  display: flex;
  gap: 16px;
  justify-content: center;
}

/* 章节样式 */
.policy-section {
  padding: 0 16px;
}
.policy-section h2 {
  position: relative;
  /* padding-left: 16px; */
}

.policy-section .section-content {
  margin-top: 24px;
}

.sub-section {
  margin-bottom: 20px;
}

.content-box {
  padding: 8px 0;
}

.notice-box {
  background: #fff7e6;
  border-left: 4px solid #ffa940;
  padding: 16px;
  margin: 16px 0;
}

.feature-list {
  margin: 16px 0;
}
.feature-list li {
  padding-left: 24px;
  margin: 8px 0;
}

.footer {
  text-align: center;
  margin: 16px;
}

h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
}

h2 {
  font-size: 24px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 20px 0 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

h3 {
  font-size: 20px;
  font-weight: 500;
  color: #262626;
  margin: 20px 0 10px;
}

h4 {
  color: #262626;
}

p {
  margin: 10px 0;
  line-height: 1.8;
  text-indent: 2em;
  text-align: justify;
}
.bold-text {
  color: #111;
}
</style>